import styled from "styled-components";

const Space = styled.div<{ height: number }>`
  width: 100%;
  height: ${({ height }) => height || 0}px;
`;

export default Space;
